import axios from 'axios'
import jssdk from 'weixin-js-sdk'
import config from './config'

// 判断当前设备
// let phoneType = ''
// if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { // 判断iPhone|iPad|iPod|iOS
//   phoneType = 'iphone'
// } else if (/(Android)/i.test(navigator.userAgent)) { // 判断Android
//   phoneType = 'android'
// }
let WX = function (config) {
  this.isTest = config.isTest
  this.debug = config.debug
}
WX.prototype.jssdk = jssdk

/**
 * 获取openid
 * router钩子里面调用
 */
WX.prototype.init = function () {
  return new Promise((resolve, reject) => {
    let isTest = this.isTest
    let openid = localStorage.openid
    console.log(openid)
    // alert(openid)
    if ((localStorage.authExpireTime < Date.parse(new Date()) / 1000 || !localStorage.authExpireTime) && !openid) { // 没有授权 没有OPENID
      // 第一次访问
      console.log('授权登录')
      // 跳转到微信授权页面，微信授权地址通过服务端获得
      axios.post('/wechat.php/Basic/wxLogin', {
        url: encodeURIComponent(window.location.href)
      }).then(function (res) {
        res = res.data
        if (res.code === 1) {
          const data = res.data
          localStorage.authExpireTime = Date.parse(new Date()) / 1000 + 60
          if (!isTest) {
            window.location.href = data.redirect_url
          } else {
            window.location.reload()
          }
        }
      })
    } else if (!openid) { // 有授权 没有OPENID
      // 刷新页面，获取数据存入vuex
      let getQueryString = function (name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
        let r = window.location.search.substr(1).match(reg)
        if (r != null) {
          return unescape(r[2])
        } else {
          return null
        }
      }
      axios.post('/wechat.php/Basic/getUserinfoByCode', {
        code: getQueryString('code'),
        is_test: isTest
      }).then(function (res) {
        res = res.data
        if (res.code === 1) {
          const data = res.data
          resolve(data)
        }
      })
      console.log('cookie生效期内登录')
    } else {
      // 已经登录
      console.log('已登录')
      reject(new Error('something bad happened'))
    }
  })
}

/**
 * 设置微信jssdk的配置项
 * 暂定App.vue中挂载
 */
WX.prototype.setConfig = function () {
  let that = this
  axios.post('/wechat.php/Basic/getJsApiSignpackage', {
    url: window.location.href
  }).then(function (res) {
    res = res.data
    if (res.code === 1) {
      const data = res.data
      console.log(data)
      that.jssdk.config({
        debug: that.debug,
        appId: data.signpackage.appid,
        timestamp: data.signpackage.timestamp,
        nonceStr: data.signpackage.noncestr,
        signature: data.signpackage.signature,
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'downloadVoice', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getNetworkType', 'openLocation', 'getLocation', 'scanQRCode', 'chooseWXPay', 'checkJsApi', 'openAddress']
      })
    }
  })
}

/**
 * 微信支付
 */
WX.prototype.wxPay = function (obj) {
  let that = this
  return new Promise((resolve, reject) => {
    that.jssdk.chooseWXPay({
      timestamp: obj.timeStamp,
      nonceStr: obj.nonceStr,
      package: obj.package,
      signType: obj.signType,
      paySign: obj.paySign,
      success: function (res) {
        // 支付成功后的回调函数
        resolve(res)
      }
    })
  })
}

/**
 * 分享给朋友
 */
WX.prototype.share = function (obj) {
  return new Promise((resolve, reject) => {
    this.jssdk.onMenuShareAppMessage({
      title: obj.title, // 分享标题
      desc: obj.desc, // 分享描述
      link: obj.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: obj.imgUrl, // 分享图标
      success: function (res) {
        resolve(res)
      }
    })
    this.jssdk.onMenuShareTimeline({
      title: obj.title, // 分享标题
      link: obj.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: obj.imgUrl, // 分享图标
      success: function (res) {
        resolve(res)
      }
    })
  })
}

let wx = new WX(config)
export default wx



// WEBPACK FOOTER //
// ./src/wx/index.js